import { render, staticRenderFns } from "./AddDialogNew.vue?vue&type=template&id=28b1e7ef&scoped=true"
import script from "./AddDialogNew.vue?vue&type=script&lang=js"
export * from "./AddDialogNew.vue?vue&type=script&lang=js"
import style0 from "./AddDialogNew.vue?vue&type=style&index=0&id=28b1e7ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1e7ef",
  null
  
)

export default component.exports